var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinEq16(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 68,
    viewBox: "0 0 54 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_895_5863)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_895_5863)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27 67.5C17.9419 59.7919 11.1789 52.6369 6.70645 46.0263C2.23403 39.4156 0 33.3015 0 27.675C0 19.2353 2.71306 12.5158 8.14355 7.50774C13.5697 2.50403 19.8581 0 27 0C34.1419 0 40.4303 2.50403 45.8565 7.50774C51.2826 12.5158 54 19.2353 54 27.675C54 33.3015 51.766 39.4156 47.2935 46.0263C42.8211 52.6369 36.0581 59.7919 27 67.5V67.5Z",
    fill: "#2E197E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 27.675C0.5 19.353 3.16975 12.7748 8.4825 7.87531L8.48252 7.8753C13.8197 2.95359 19.9883 0.5 27 0.5C34.0117 0.5 40.1802 2.95355 45.5173 7.87517C50.826 12.7748 53.5 19.3532 53.5 27.675C53.5 33.1679 51.3183 39.185 46.8794 45.7461C42.4947 52.2272 35.8757 59.2569 27 66.8429C18.1243 59.2569 11.5053 52.2272 7.12058 45.7461C2.68166 39.185 0.5 33.1679 0.5 27.675Z",
    stroke: "black"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M26.9999 48.87C39.3742 48.87 49.4055 38.8387 49.4055 26.4644C49.4055 14.0901 39.3742 4.05872 26.9999 4.05872C14.6256 4.05872 4.59424 14.0901 4.59424 26.4644C4.59424 38.8387 14.6256 48.87 26.9999 48.87Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 37C25.36 37 23.81 36.685 22.35 36.055C20.89 35.425 19.615 34.565 18.525 33.475C17.435 32.385 16.575 31.11 15.945 29.65C15.315 28.19 15 26.64 15 25C15 23.34 15.315 21.785 15.945 20.335C16.575 18.885 17.435 17.615 18.525 16.525C19.615 15.435 20.89 14.575 22.35 13.945C23.81 13.315 25.36 13 27 13C28.66 13 30.215 13.315 31.665 13.945C33.115 14.575 34.385 15.435 35.475 16.525C36.565 17.615 37.425 18.885 38.055 20.335C38.685 21.785 39 23.34 39 25C39 26.64 38.685 28.19 38.055 29.65C37.425 31.11 36.565 32.385 35.475 33.475C34.385 34.565 33.115 35.425 31.665 36.055C30.215 36.685 28.66 37 27 37ZM33.15 22.21L35.22 21.49L35.76 19.57C35.08 18.51 34.24 17.605 33.24 16.855C32.24 16.105 31.11 15.53 29.85 15.13L27.9 16.42V18.52L33.15 22.21ZM20.88 22.21L26.1 18.52V16.42L24.18 15.13C22.92 15.53 21.79 16.105 20.79 16.855C19.79 17.605 18.95 18.51 18.27 19.57L18.93 21.49L20.88 22.21ZM19.26 31.81L21.06 31.6L22.23 29.65L20.37 23.92L18.24 23.2L16.8 24.37C16.8 25.81 16.96 27.125 17.28 28.315C17.6 29.505 18.26 30.67 19.26 31.81V31.81ZM27 35.2C27.54 35.2 28.085 35.15 28.635 35.05C29.185 34.95 29.76 34.82 30.36 34.66L31.35 32.5L30.39 30.85H23.64L22.68 32.5L23.67 34.66C24.19 34.82 24.74 34.95 25.32 35.05C25.9 35.15 26.46 35.2 27 35.2ZM23.82 29.05H30.06L31.89 23.56L27 20.05L22.02 23.56L23.82 29.05ZM34.77 31.81C35.75 30.67 36.4 29.505 36.72 28.315C37.04 27.125 37.2 25.81 37.2 24.37L35.76 23.38L33.66 23.92L31.8 29.65L32.94 31.6L34.77 31.81Z",
    fill: "#516274"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_895_5863",
    x: -4,
    y: 0,
    width: 62,
    height: 75.5,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_895_5863"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_895_5863",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_895_5863"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 67.5,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinEq16);
export default __webpack_public_path__ + "static/media/pin-eq-16.458e130fd5ef4eb4262928ea166c32af.svg";
export { ForwardRef as ReactComponent };